import { render, staticRenderFns } from "./PasswordResetRoute.vue?vue&type=template&id=265e5270&scoped=true&"
import script from "./PasswordResetRoute.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetRoute.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordResetRoute.vue?vue&type=style&index=0&id=265e5270&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e5270",
  null
  
)

export default component.exports